export default {"src":"/_next/static/media/foodbowl.8fdee5b4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};